export const ATTENDANCE_STATES = {
  WAITING_ATTENDANCE: 'AGUARDANDO_ATENDIMENTO',
  ATTENDANCE_STARTED: 'ATENDIMENTO_INICIADO',
  CALL_STARTED: 'CHAMADA_INICIADA',
  CALL_RESTARTED: 'CHAMADA_REINICIADA',
  CALL_ENDED: 'CHAMADA_ENCERRADA',
  ATTENDANCE_CANCELLED_MEDIC: 'ATENDIMENTO_CANCELADO_PELO_MEDICO',
  ATTENDANCE_CANCELLED_TIME: 'ATENDIMENTO_CANCELADO_POR_ATRASO',
  ATTENDANCE_END: 'ATENDIMENTO_CONCLUIDO',
  ATTENDANCE_CANCELLED_PATIENT_BLOCKED:
    'ATENDIMENTO_CANCELADO_PACIENTE_BLOQUEADO',
}
export const SCHEDULING_STATES = {
  ATTENDANCE_LATE: 'ATRASADO_MEDICO_NOTIFICADO',
  RESCHEDULED: 'REAGENDADO',
}

export const queueDataTranslate = {
  idProtocolo: 'id',
  status: 'status',
  idTipoProfissional: 'council',
  tipoProfissional: 'councilString',
  npsRespondido: 'npsAnswered',
  pacienteOnline: 'patientOnline',
  posicaoFila: 'queuePosition',
  tamanhoFila: 'queueSize',
  tempoEstimado: 'estimatedTime',
  tempoEstimadoInicial: 'initialEstimatedTime',
  tempoMaximoEspera: 'maximumWaitTime',
  tempoMinimoEspera: 'minimumWaitTime',
  idProfissional: 'professionalId',
  nomeProfissional: 'professionalName',
  fotoProfissional: 'professionalPhoto',
  especialidadeProfissional: 'professionalSpeciality',
  sexoProfissional: 'professionalSex',
  anexos: 'attachments',
  dataHoraAgendada: 'scheduledDate',
  statusAgendamento: 'scheduledStatus',
  atendimentoPsicologiaViva: 'psyAliveAttendance',
  idAtendimento: 'attendanceId',
}

export const callDataTranslate = {
  idAtendimento: 'attendanceId',
  idChamada: 'callId',
  idEspecialidade: 'specialityId',
  idProfissional: 'professionalId',
  nomeEspecialidade: 'speciality',
  nomeProfissional: 'professionalName',
  sexo: 'sex',
  statusFila: 'queueStatus',
  tipoMeeting: 'meetingType',
  tokenAtendimento: 'attendanceToken',
  tokenChamada: 'callToken',
  urlFoto: 'photo',
  statusAgendamento: 'scheduledStatus',
  zoomMeetingId: 'zoomMeetingId',
  zoomMeetingPasswd: 'zoomMeetingPass',
  zoomMeetingUrl: 'zoomMeetingUrl',
}
